import { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

export default function AdminPharmacists() {
  // create pharmacist
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [type, setType] = useState("internal");
  const [hospital, setHospital] = useState("");
 
  // global data
  const [hospitals, setHospitals] = useState([]);
  const [pharmacists, setPharmacists] = useState([]);

  // internal salary + notes
  const [selectedInternalId, setSelectedInternalId] = useState("");
  const [salary, setSalary] = useState("");
  const [adminNote, setAdminNote] = useState("");
  const [noteHistory, setNoteHistory] = useState([]);

  const load = async () => {
    const h = await axios.get("/hospitals/");
    const p = await axios.get("/admin/pharmacists/list/");
    setHospitals(h.data);
    setPharmacists(p.data);
  };

  useEffect(() => {
    load();
  }, []);

  // when admin selects internal pharmacist
  useEffect(() => {
    if (!selectedInternalId) return;
    axios.get(`/admin/pharmacists/${selectedInternalId}/detail/`).then(res => {
      setSalary(res.data.salary || "");
      setNoteHistory(res.data.notes || []);
    console.log("Selected:", selectedInternalId);});
  }, [selectedInternalId]);

  const create = async () => {
    await axios.post("/admin/pharmacists/", {
      name,
      phone,
      pharmacist_type: type,
      hospital: type === "hospital" ? hospital : null,
    });
    setName(""); setPhone(""); setHospital("");
    load();
  };

  const toggle = async (id) => {
    await axios.patch(`/admin/pharmacists/${id}/toggle/`);
    load();
  };

  const updateSalaryAndNote = async () => {
    if (!selectedInternalId) return;
    await axios.patch(`/admin/pharmacists/${selectedInternalId}/update/`, {
      salary,
      note: adminNote,
    });
    setAdminNote("");
    // reload history
    const res = await axios.get(`/admin/pharmacists/${selectedInternalId}/detail/`);
    setNoteHistory(res.data.notes || []);
  };

  const internalPharmacists = pharmacists.filter(p => p.pharmacist_type === "internal");
const hospitalPharmacists = pharmacists.filter(
  p => p.pharmacist_type && p.pharmacist_type.includes("hospital")
);


  return (
    <div style={{ padding: 20, maxWidth: 1100, margin: "auto" }}>
      <h2>Admin – Pharmacist Management</h2>

      {/* SECTION 1: INTERNAL SALARY & NOTES */}
      <div style={{ border: "1px solid #ddd", padding: 15, borderRadius: 8, marginBottom: 20 }}>
        <h3>Internal Pharmacist – Salary & Notes</h3>


<select
  value={selectedInternalId}
  onChange={e => setSelectedInternalId(e.target.value)}
>
  <option value="">Select Internal Pharmacist</option>
  {internalPharmacists.map(p => (
    <option key={p.id} value={p.id}>
      {p.name} ({p.phone})
    </option>
  ))}

</select>
{selectedInternalId > 0 && (
  <div style={{ marginTop: 10 }}>
    <input
      placeholder="Salary"
      value={salary}
      onChange={e => setSalary(e.target.value)}
    />

 <input
      placeholder="Admin note"
      value={adminNote}
      onChange={e => setAdminNote(e.target.value)}
    />

    <button onClick={updateSalaryAndNote}>
      Update Salary / Add Note
    </button>
  </div>
)}

<h4>Previous Admin Notes</h4>
{noteHistory.length === 0 && <p>No notes yet</p>}
{noteHistory.map((n, i) => (
  <div key={i}>
    <b>{new Date(n.created_at).toLocaleString()}</b>
    <p>{n.note}</p>
    <hr />
  </div>
))}

            



          </div>
      

      {/* SECTION 2: ADD NEW PHARMACIST */}
      <div style={{ border: "1px solid #ddd", padding: 15, borderRadius: 8, marginBottom: 20 }}>
        <h3>Add New Pharmacist</h3>
        <input placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
        <input placeholder="Phone" value={phone} onChange={e => setPhone(e.target.value)} />

        <select value={type} onChange={e => setType(e.target.value)}>
          <option value="internal">Internal</option>
          <option value="hospital">Hospital</option>
        </select>

        {type === "hospital" && (
          <select value={hospital} onChange={e => setHospital(e.target.value)}>
            <option value="">Select Hospital</option>
            {hospitals.map(h => (
              <option key={h.id} value={h.id}>{h.name}</option>
            ))}
          </select>
        )}

        <button onClick={create}>Add Pharmacist</button>
      </div>

      {/* SECTION 3: LIST ALL PHARMACISTS */}
      <div style={{ border: "1px solid #ddd", padding: 15, borderRadius: 8 }}>
        <h3>All Pharmacists</h3>

        <h4>Internal Pharmacists</h4>
        {internalPharmacists.map(p => (
          <div key={p.id} style={{ marginBottom: 6 }}>
            {p.name} – {p.phone}
            <button onClick={() => toggle(p.id)} style={{ marginLeft: 10 }}>
              {p.is_active ? "Block" : "Unblock"}
            </button>
          </div>
        ))}

<h4>Hospital Pharmacists</h4>
{hospitalPharmacists.length === 0 && <p>No hospital pharmacists</p>}

{hospitalPharmacists.map(p => (
  <div key={p.id} style={{ marginBottom: 8 }}>
    <b>{p.name}</b> – {p.phone}
    {p.alternate_phone && <> | Alt: {p.alternate_phone}</>}
    – {p.hospital_name || "No Hospital"}

    <button
      style={{ marginLeft: 10 }}
      onClick={() => {
        const newPhone = prompt(
          "Enter alternate phone number",
          p.alternate_phone || ""
        );
        if (newPhone) {
          axios.patch(`/admin/pharmacists/${p.user_id || p.id}/alternate-phone/`, {
            alternate_phone: newPhone,
          }).then(load);
        }
      }}
    >
      Add / Update Alt Phone
    </button>

    <button
      style={{ marginLeft: 6 }}
      onClick={() => toggle(p.id)}
    >
      {p.is_active ? "Block" : "Unblock"}
    </button>
  </div>
))}


      </div>
    </div>
  );
}
